import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import { CiSearch } from "react-icons/ci";
import { useParams } from "react-router-dom";
import { Form, Table } from "react-bootstrap";
import { studyOtherSettingsServices } from "../../../../APIServices/studyOtherSettingsServices";
import { studyOnboardingService } from "../../../../APIServices/studyOnboarding";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Swal from "sweetalert2";
import SplitPane from "react-split-pane";
import Pagination from "../../../Pagination";
import UseToggle from "../../../../Hooks/UseToggle";
import UpdateStudyTemperatureMetadata from "./UpdateStudyTemperatureMetadata";
import AddNewStudyTemperatureMetadata from "./AddNewStudyTemperatureMetadata";
import DeletedStudyTemperatureMetadata from "./DeletedStudyTemperatureMetadata";
import StudyTemperatureMetadataActivities from "./StudyTemperatureMetadataActivities";
import { eiwrsTemperatureMetadataServices } from "../../../../APIServices/EIWRS/ShipmentManagement/eiwrsTemperatureMetadataServices";

const StudyTemperatureMetadataDataList = ({ onMouseDown, tableRef }) => {
  let { studyId } = useParams();
  const { toggle, setToggle, toggle1, setToggle1, toggle2, setToggle2 } = UseToggle();
  const [searchData, setSearchData] = useState("");
  const [temperatureData, setTemperatureData] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [temperatureList, setTemperatureList] = useState([]);
  const [temperatureCount, setTemperatureCount] = useState(0);
  const [deletedStudySiteTemperature, setDeletedStudyTemperature] = useState([]);
  const [deletedStudySiteTemperatureCount, setDeletedStudyTemperatureCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("activities");
  const [temperatureId, setTemperatureId] = useState("");
  const [activityLoader, setActivityLoader] = useState(false);
  const [temperatureActivity, setTemperatureActivity] = useState([]);
  const [temperatureActivityCount, setTemperatureActivityCount] = useState(0);
  const [tableColumns, setTableColumns] = useState({});
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(temperatureCount / itemsPerPage);

  const getEIWRSTemperatureMetadataData = async (e) => {
    setLoading(true);
    let data = await eiwrsTemperatureMetadataServices.getEIWRSTemperatureMetadataData(
      "active",
      studyId,
      searchData,
      pageNumber,
      itemsPerPage
    );
    setTemperatureList(data?.data || []);
    setTemperatureCount(data?.count || 0);
    setLoading(false);
  };

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getDeletedEIWRSTemperatureMetadataData = async (
    pageNumberDeleted,
    itemsPerPageDeleted
  ) => {
    let data = await eiwrsTemperatureMetadataServices.getEIWRSTemperatureMetadataData(
      "deleted",
      studyId,
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setDeletedStudyTemperature(data?.data || []);
    setDeletedStudyTemperatureCount(data?.count || 0);
  };

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "studySiteTemperature",
      studyId,
      temperatureData?.temperatureId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setTemperatureActivity(data?.data || []);
    setTemperatureActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  useEffect(() => {
    setActiveTab("activities");
  }, [temperatureData]);

  useEffect(() => {
    getEIWRSTemperatureMetadataData();
  }, [searchData, pageNumber, itemsPerPage]);

  const softDeleteRestoreEIWRSTemperatureMetadata = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} Site Temperature!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.id = id;
        userData.type = type;
        let data =
          await eiwrsTemperatureMetadataServices.softDeleteRestoreEIWRSTemperatureMetadata(
            userData
          );
        if (data?.statusCode === 200) {
          getEIWRSTemperatureMetadataData();
          setTemperatureId("");
          getDeletedEIWRSTemperatureMetadataData();
          if (type === "restore") {
            getDeletedEIWRSTemperatureMetadataData(pageNumberDeleted, itemsPerPageDeleted);
            setToggle1();
          }
        }
      }
    });
  };

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-1">
          <i
            title={isFormOpen ? "Close Form" : "Add New"}
            onClick={() => {
              setIsFormOpen(!isFormOpen);
              setTemperatureId("");
            }}
            className={`fa-solid ${isFormOpen ? "fa-table-list" : "fa-plus-square CP"
              }`}
          />
          <div className="vr"></div>
          {temperatureCount > 0 && (
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 250, padding: "3px 10px" }}
              ></Form.Control>
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 4, right: 7 }}
              />
            </div>
          )}
        </div>
        <div className="hstack gap-2">
          {StudyMode === "DBP Mode" &&
            deletedStudySiteTemperatureCount > 0 &&
            <button
              onClick={() => {
                setToggle1();
                getDeletedEIWRSTemperatureMetadataData(
                  pageNumberDeleted,
                  itemsPerPageDeleted
                );
              }}
              className={`updateProfile`}
            >
              Deleted History
            </button>
          }
        </div>
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
        minSize={temperatureId ? "40%" : "100%"}
      >
        <SplitPane
          split="vertical"
          minSize={20}
          className="position-relative"
          defaultSize={isFormOpen ? "20%" : "100%"}
        >
          {isFormOpen && (
            <AddNewStudyTemperatureMetadata getEIWRSTemperatureMetadataData={getEIWRSTemperatureMetadataData} />
          )}
          {loading ? (
            <PageLoader />
          ) : temperatureCount === 0 ? (
            <NoDataFoundTable MSG={"Study Site Temperature not found!"} />
          ) : temperatureList?.length === 0 ? (
            <NoDataFoundTable MSG={"Search Study Site Temperature not found!"} />
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>
                      Temperature
                    </th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 2)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Edit
                    </th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 3)}
                      style={{ width: 55 }}
                      className="text-center"
                    >
                      Delete
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {temperatureList?.map((temperatureData, index) => (
                    <tr
                      key={index}
                      title="View Details"
                      className={`${temperatureData?.type !== "predefine" && "CP"} ${temperatureId === temperatureData?._id ? "highlighted" : ""
                        }`}
                      onClick={() => setIsFormOpen(false)}
                    >
                      <td
                        onClick={() => {
                          setTemperatureData(temperatureData);
                          setTemperatureId(temperatureData?._id);
                        }}
                        className="text-center"
                      >
                        {index + 1 + startIndex}.
                      </td>
                      <td
                        onClick={() => {
                          setTemperatureData(temperatureData);
                          setTemperatureId(temperatureData?._id);
                        }}
                      >
                        {temperatureData?.temperature}
                      </td>
                      <td
                        className="text-center CP"
                        title={`Update ${temperatureData?.temperature}`}
                        onClick={(e) => {
                          setTemperatureData(temperatureData);
                          setToggle();
                          e.stopPropagation();
                        }}
                        style={{ pointerEvents: "auto" }}
                      >
                        <FaEdit className="text-muted" />
                      </td>
                      <td
                        className="text-center CP"
                        title={`Delete ${temperatureData?.temperature}`}
                        onClick={(e) => {
                          softDeleteRestoreEIWRSTemperatureMetadata(
                            temperatureData?._id,
                            "delete"
                          );
                        }}
                      >
                        <FaTrash className={"text-danger"} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={temperatureCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </>
          )}
        </SplitPane>
        {temperatureId && (
          <div className={isFullScreen ? "full-screen-component" : ""}>
            <div className="hstack paginate fixed_tab_button justify-content-between pt-1 border-bottom bg-light">
              <div className="hstack me-1 gap-1">
                {["activities"].map(
                  (tab) => (
                    <button
                      key={tab}
                      className={`buttonForTabs px-2 ${activeTab === tab ? "activee" : ""
                        }`}
                      onClick={() => setActiveTab(tab)}
                      title={tab.charAt(0).toUpperCase() + tab.slice(1)}
                    >
                      {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                  )
                )}
              </div>
              <div className="d-flex gap-1">
                <div className="toolbar">
                  <i
                    className="fa-solid fa-angle-down"
                    onClick={() => setTemperatureId(false)}
                  ></i>
                </div>
                <div className="toolbar">
                  <i
                    className={`fa-solid me-2 ${!isFullScreen ? "fa-maximize" : "fa-minimize"
                      }`}
                    title={!isFullScreen ? "Full Mode" : "Original Mode"}
                    onClick={toggleFullScreen}
                  ></i>
                </div>
              </div>
            </div>
            {activeTab === "activities" && (
              <StudyTemperatureMetadataActivities
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                temperatureActivity={temperatureActivity}
                activityLoader={activityLoader}
                getStudyAuditTrials={getStudyAuditTrials}
                temperatureData={temperatureData}
                temperatureActivityCount={temperatureActivityCount}
                isFullScreen={isFullScreen}
              />
            )}
          </div>
        )}
      </SplitPane>
      <UpdateStudyTemperatureMetadata
        Show={!toggle}
        Hide={setToggle}
        temperatureData={temperatureData}
        setTemperatureId={setTemperatureId}
        getEIWRSTemperatureMetadataData={getEIWRSTemperatureMetadataData}
        Title={"Update Study Site Temperature"}
      />
      <DeletedStudyTemperatureMetadata
        Show={!toggle1}
        Hide={setToggle1}
        setTemperatureId={setTemperatureId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        deletedStudySiteTemperature={deletedStudySiteTemperature}
        getDeletedEIWRSTemperatureMetadataData={getDeletedEIWRSTemperatureMetadataData}
        deletedStudySiteTemperatureCount={deletedStudySiteTemperatureCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        softDeleteRestoreEIWRSTemperatureMetadata={softDeleteRestoreEIWRSTemperatureMetadata}
        Title={"Deleted Study Site Temperature History"}
      />
    </>
  );
};

export default StudyTemperatureMetadataDataList;
